import Typography from "@marginly/ui/components/typography";
import React from "react";

import Space from "@/components/common/space";
import { useRequest } from "@/components/raffle/hooks";
import { CommonModal } from "@/components/raffle/results/common-modal/common-modal";
import { formatNum } from "@/lp/util/format";

import {
  Header,
  RaffleLine,
  RaffleLineSkeleton,
  RaffleWrapper,
} from "./winners-modal.styled";

function useTickets(contestId: number, raffleId: number) {
  return useRequest<Ticket[]>(
    [],
    `contest/${contestId}/raffles/tickets?raffleId=${raffleId}&winTicketsOnly=true`,
  );
}

export const WinnersModal = ({
  count,
  contestId,
  raffleId,
  raffle,
  memberNumber,
  onHide,
}: {
  count?: string;
  contestId: number;
  raffleId: number;
  raffle: Raffle;
  memberNumber: number;
  onHide?: () => void;
}) => {
  const tickets = useTickets(contestId, raffleId);

  if (!raffle) return null;

  return (
    <CommonModal
      onHide={onHide}
      header={
        <Header>
          <div className="first-line">
            <Typography headerL>{count} Raffle</Typography>
            <a href={raffle.ipfsLink} target="_blank">
              <Typography action className="action">
                Check On IPFS
              </Typography>
            </a>
          </div>
          <Space height={12} heightMobile={12} />
          <Typography className="subheader">
            {raffle.numberOfWinners} winners from {formatNum(memberNumber)}{" "}
            participants
          </Typography>
        </Header>
      }
    >
      <Space height={24} heightMobile={24} />
      <RaffleWrapper>
        {tickets.length
          ? tickets.map((ticket, index) => (
              <RaffleLine key={ticket.number}>
                <span className="index">{index + 1}</span>
                <span className="address">
                  ...{ticket.userAddress.slice(-4)}
                </span>
                <span className="wide">
                  <span className="number">
                    {ticket.winAmountUsd === 1000 ? (
                      <img src="/images/prize-1000.png" alt="" />
                    ) : ticket.winAmountUsd === 50 ? (
                      <img src="/images/prize-50.png" alt="" />
                    ) : (
                      <img src="/images/ticket-green.svg" alt="" />
                    )}
                    #{ticket.number}
                  </span>
                </span>
                <span className="win-amount">Won ${ticket.winAmountUsd}</span>
              </RaffleLine>
            ))
          : Array(raffle.numberOfWinners)
              .fill(true)
              .map((_, index) => <RaffleLineSkeleton key={index} />)}
      </RaffleWrapper>
    </CommonModal>
  );
};
